import React, { useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  Box,
  IconButton,
} from "@mui/material";
import {
  Home as HomeIcon,
  Settings as SettingsIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import HistoryIcon from '@mui/icons-material/History';

const drawerWidth = 240;

const Nav = ({ isOpen, toggleSidebar }) => {
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  return (
    <>
      <IconButton
        onClick={toggleSidebar}
        sx={{
          position: "fixed",
          top: 20,
          left: isOpen ? `${drawerWidth}px` : "15px",
          marginLeft: "-25px",
          transition: "left 0.3s ease-in-out",
          backgroundColor: "#ededed",
          border: "1px solid #c4c4c4",
          color: "#2c2c2c",
          zIndex: 1300,
          padding: "10px",
          "&:hover": { backgroundColor: "#dcdcdc" },
        }}
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>

      <Drawer
        variant="permanent"
        sx={{
          width: isOpen ? drawerWidth : 0,
          flexShrink: 0,
          transition: "width 0.3s ease-in-out",
          "& .MuiDrawer-paper": {
            width: isOpen ? drawerWidth : 0,
            boxSizing: "border-box",
            backgroundColor: "#ededed",
            color: "#2c2c2c",
            overflowX: "hidden",
            transition: "width 0.3s ease-in-out",
          },
        }}
      >
        <Box sx={{ padding: "25px", textAlign: "center" }}>
          <img
            src="/life-pro-nutrition-logo.svg"
            alt="Life Pro Nutrition"
            style={{ width: "100%" }}
          />
        </Box>
        <Divider />
        <List>
          <ListItem
            button
            onClick={() => navigate("/")}
            sx={{
              "&:hover": { backgroundColor: "#dcdcdc" },
              cursor: "pointer",
            }}
          >
            <ListItemIcon>
              <HomeIcon sx={{ color: "#2c2c2c" }} />
            </ListItemIcon>
            <ListItemText primary="Inicio" sx={{ color: "#2c2c2c" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => navigate("/altausuarios")}
            sx={{
              "&:hover": { backgroundColor: "#dcdcdc" },
              cursor: "pointer",
            }}
          >
            <ListItemIcon>
              <PersonAddAltIcon sx={{ color: "#2c2c2c" }} />
            </ListItemIcon>
            <ListItemText primary="Alta usuario" sx={{ color: "#2c2c2c" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => navigate("/bajausuario")}
            sx={{
              "&:hover": { backgroundColor: "#dcdcdc" },
              cursor: "pointer",
            }}
          >
            <ListItemIcon>
              <PersonRemoveIcon sx={{ color: "#2c2c2c" }} />
            </ListItemIcon>
            <ListItemText primary="Baja usuario" sx={{ color: "#2c2c2c" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => navigate("/LPD")}
            sx={{
              "&:hover": { backgroundColor: "#dcdcdc" },
              cursor: "pointer",
            }}
          >
            <ListItemIcon>
              <SettingsIcon sx={{ color: "#2c2c2c" }} />
            </ListItemIcon>
            <ListItemText primary="LPD PDF" sx={{ color: "#2c2c2c" }} />
          </ListItem>

          {userRole === "admin" && (
            <ListItem
              button
              onClick={() => navigate("/historico")}
              sx={{
                "&:hover": { backgroundColor: "#dcdcdc" },
                cursor: "pointer",
              }}
            >
              <ListItemIcon>
                <HistoryIcon sx={{ color: "#2c2c2c" }} />
              </ListItemIcon>
              <ListItemText primary="Historico" sx={{ color: "#2c2c2c" }} />
            </ListItem>
          )}

          <ListItem
            button
            onClick={() => navigate("/logout")}
            sx={{
              "&:hover": { backgroundColor: "#dcdcdc" },
              cursor: "pointer",
            }}
          >
            <ListItemIcon>
              <LogoutIcon sx={{ color: "#2c2c2c" }} />
            </ListItemIcon>
            <ListItemText primary="Cerrar sesion" sx={{ color: "#2c2c2c" }} />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default Nav;
